module.exports = __webpack_public_path__ + "images/kihnu/ms-icon-144x144.png";